<div class="container-fluid grey-color form-wrapper fixed-min-header-height change-password">
  <div class="row">
      <div class="col-12">
          <div class="form-box">
              <div class="top-detail">
                  <a href="/" title="Back to Home"><img alt="world of sweets logo"
                          src="../../assets/images/bonds-logo-footer.svg" /></a>
                  <h1>Change Password</h1>
                  <p>Change password for your account</p>
              </div>
      
              <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" autocomplete="off">
                  <div class="form-group">
                    <label >Current Password <sup>*</sup></label>
                    <input [type]="fieldTextType ? 'text' : 'password'" class="form-control password" formControlName="old_password" placeholder="Current Password">
                    <div class="input-group-append">
                      <i
                        [ngClass]="{
                          'fa-eye-slash': !fieldTextType,
                          'fa-eye': fieldTextType
                        }"
                        (click)="toggleFieldTextType()"
                      ></i>
                  </div>
                    <div *ngIf="submitted && changePasswordForm.controls.old_password.errors" class="error">
                      <div *ngIf="changePasswordForm.controls.old_password.errors.required"><img src="/assets/images/error.svg" /> Current password is required</div>
                      <div *ngIf="changePasswordForm.controls.old_password.errors.minlength"><img src="/assets/images/error.svg" /> Password must be at least 6 characters</div>
                      <div *ngIf="changePasswordForm.controls.old_password.errors.maxlength"><img src="/assets/images/error.svg" /> Password not be greater then 15 characters</div>
                    </div>
                </div> 
                <div class="divider"></div>
                  <div class="form-group">
                      <label >New Password <sup>*</sup></label>
                      <input [type]="fieldTextType1 ? 'text' : 'password'" class="form-control password" formControlName="new_password"  placeholder="New Password">
                      <div class="input-group-append">
                        <i
                          [ngClass]="{
                            'fa-eye-slash': !fieldTextType1,
                            'fa-eye': fieldTextType1
                          }"
                          (click)="toggleFieldTextType1()"
                        ></i>
                    </div>
                      <div *ngIf="submitted && changePasswordForm.controls.new_password.errors" class="error">
                        <div *ngIf="changePasswordForm.controls.new_password.errors.required"><img src="/assets/images/error.svg" /> New password is required</div>
                        <div *ngIf="changePasswordForm.controls.new_password.errors.minlength"><img src="/assets/images/error.svg" /> Password must be at least 6 characters</div>
                        <div *ngIf="changePasswordForm.controls.new_password.errors.maxlength"><img src="/assets/images/error.svg" /> Password not be greater then 15 characters</div>
                      </div>
                  </div>
                  <div class="form-group mb-0">
                      <label > Confirm Password <sup>*</sup></label>
                      <input [type]="fieldTextType2 ? 'text' : 'password'" class="form-control password" formControlName="confirm_password" placeholder="Confirm Password">
                      <div class="input-group-append">
                        <i
                          [ngClass]="{
                            'fa-eye-slash': !fieldTextType2,
                            'fa-eye': fieldTextType2
                          }"
                          (click)="toggleFieldTextType2()"
                        ></i>
                    </div>
                      <div *ngIf="submitted && changePasswordForm.controls.confirm_password.errors" class="error">
                        <div *ngIf="changePasswordForm.controls.confirm_password.errors.required"><img src="/assets/images/error.svg" /> Confirm password is required</div>
                        <div *ngIf="changePasswordForm.controls.confirm_password.errors.minlength"><img src="/assets/images/error.svg" /> Password must be at least 6 characters</div>
                        <div *ngIf="changePasswordForm.controls.confirm_password.errors.maxlength"><img src="/assets/images/error.svg" /> Password not be greater then 15 characters</div>
                      </div>
                      <div class="error" *ngIf="submitted && !changePasswordForm.controls.confirm_password.errors"> {{confirmErrMessage}} </div>
                      <div class="error" *ngIf="!confirmErrMessage">{{serverErrMessage}}</div>                  </div>
                  <button type="submit" class="btn primary-btn">Change Password</button>
              </form>
          </div>
      </div>
  </div>
</div>